<div class="boleto-item">
  <div class="vencimento-valor-bruto" (click)="boletoCollapse.toggle()" [attr.aria-expanded]="!isBoletoCollapsed"
    aria-controls="collapseExample">
    <span class="strong__class">
      {{boleto.venc}}
    </span>
    <span class="strong__class">
      {{boleto.vlrBruto || 'Sem dados'}}
    </span>
    <img [ngClass]="{'rotate': isBoletoCollapsed}" src="/assets/images/simbolos/setaPreta.svg">
  </div>
  <div #boletoCollapse="ngbCollapse" [(ngbCollapse)]="isBoletoCollapsed">
    <div class="collapse-boleto-info">
      <span class="strong__class">
        Título:{{boleto.codFatura}}
      </span>
      <span class="strong__class">
        Data: {{boleto.data}}
      </span>
      <span class="strong__class">
        Origem: {{boleto.origem || 'Sem dados'}}
      </span>
      <div *ngIf="environment.company === 'apnetworks'; then apnetworksCliente else kmDoBrasilCliente"></div>
      <ng-template #apnetworksCliente>
        <span class="strong__class">
          Cliente: {{boleto.nomeCliente || boleto.nomeFantasiaCliente || 'Sem dados'}}
        </span>
      </ng-template>
      <ng-template #kmDoBrasilCliente>
        <span class="strong__class">
          Cliente: {{boleto.nomeFantasiaCliente || boleto.nomeCliente || 'Sem dados'}}
        </span>
      </ng-template>
    </div>
    <div class="collapse-boleto-buttons">
      <button (click)="downloadBoleto(boleto)">
        Download
      </button>
    </div>
  </div>
</div>

<app-modal-download-boleto (closeModal)="closeModal()"></app-modal-download-boleto>